// ============================================
// DCTOS BEHAVIORAL TRAIT CONFIGURATION
// ============================================
// D = Drive (Drive) - How you approach challenges
// C = Connection (Connection) - How you interact with others
// T = Task (Task) - How you respond to pace
// O = Order (Order) - How you follow rules/procedures
// S = Style (Style) - How you make decisions
// ============================================

// Aurora Palette - Northern lights inspired
export const DCTOS_COLORS = {
  drive: '#FB923C',      // D - Orange
  connection: '#E879F9', // C - Fuchsia
  task: '#22D3EE',       // T - Cyan
  order: '#4ADE80',      // O - Green
  style: '#CBD5E1',      // S - Light Slate
} as const;

export const DCTOS_GRADIENTS = {
  drive: ['#FB923C', '#EA580C'] as [string, string],
  connection: ['#E879F9', '#C026D3'] as [string, string],
  task: ['#22D3EE', '#0891B2'] as [string, string],
  order: ['#4ADE80', '#16A34A'] as [string, string],
  style: ['#CBD5E1', '#64748B'] as [string, string],
} as const;

export const DCTOS_NAMES = {
  D: 'Drive',
  C: 'Connection',
  T: 'Task',
  O: 'Order',
  S: 'Style',
} as const;

export const DCTOS_LETTERS = ['D', 'C', 'T', 'O', 'S'] as const;

// Map trait keys to DCTOS letters
export const TRAIT_TO_DCTOS_LETTER: Record<string, string> = {
  dominance: 'D',
  extraversion: 'C',
  patience: 'T',
  formality: 'O',
  objectivity: 'S',
};

// Map DCTOS letters to colors
export const getDctosColor = (letter: 'D' | 'C' | 'T' | 'O' | 'S'): string => {
  const colorMap = {
    D: DCTOS_COLORS.drive,
    C: DCTOS_COLORS.connection,
    T: DCTOS_COLORS.task,
    O: DCTOS_COLORS.order,
    S: DCTOS_COLORS.style,
  };
  return colorMap[letter];
};

// Map DCTOS letters to gradients
export const getDctosGradient = (letter: 'D' | 'C' | 'T' | 'O' | 'S'): [string, string] => {
  const gradientMap = {
    D: DCTOS_GRADIENTS.drive,
    C: DCTOS_GRADIENTS.connection,
    T: DCTOS_GRADIENTS.task,
    O: DCTOS_GRADIENTS.order,
    S: DCTOS_GRADIENTS.style,
  };
  return gradientMap[letter];
};
